import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getOrderRemainingHoursReports(params: any): AxiosPromise {
    return EndPointService.get('/order-remaining-hours-report', { params });
}

function getOrderRemainingHoursReport(id: number | string): AxiosPromise {
    return EndPointService.get(`/orderRemainingHoursReports/${id}`);
}

function deleteOrderRemainingHoursReport(id: number | string): AxiosPromise {
    return EndPointService.delete(`/orderRemainingHoursReports/${id}`);
}

function createOrderRemainingHoursReport(payload: any): AxiosPromise {
    return EndPointService.post('/orderRemainingHoursReports', payload);
}

function updateOrderRemainingHoursReport(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/orderRemainingHoursReports/${id}`, { ...payload });
}

export default {
    getOrderRemainingHoursReports,
    getOrderRemainingHoursReport,
    deleteOrderRemainingHoursReport,
    createOrderRemainingHoursReport,
    updateOrderRemainingHoursReport,
};
